const translations = {
    en: {
        shared: {
            footer: {
                hotel_text_communications: "For any request about your stay you can write to ${hotel_email}",
                privacy_text_communications: "For privacy and GPDR related communications only, you can contact us at ${privacy_email}",
                accessibility_text: "Accessibility Statement",
                accessibility_link: "https://www-bestwestern-it.translate.goog/accessibility_bestfriend/?_x_tr_sl=it&_x_tr_tl=en&_x_tr_hl=en&_x_tr_pto=wapp",
                ownership: 'Each BWH® Hotels property is independently owned and operated.',
                antispam1: "BWH Hotels never ask for personal data or payment via WhatsApp or SMS messages.",
                antispam2: "If you have any doubts, we recommend that you contact the booked property directly or access the booking website.",
                mail_unsubscribe: " ",
                mail_unsubscribe_link: "Manage notifications for this booking"
            }
        }
    },
    de: {
        shared: {
            footer: {
                hotel_text_communications: "Für alle Anfragen zu Ihrem Aufenthalt können Sie an ${hotel_email} schreiben",
                privacy_text_communications: "Im Gegenteil können Sie uns ausschließlich für Mitteilungen zum Datenschutz oder zur DSGVO unter ${privacy_email} kontaktieren",
                accessibility_text: "Erklärung zur Barrierefreiheit",
                accessibility_link: "https://www-bestwestern-it.translate.goog/accessibility_bestfriend/?_x_tr_sl=it&_x_tr_tl=de&_x_tr_hl=de&_x_tr_pto=wapp",
                ownership: 'Each BWH® Hotels property is independently owned and operated.',
                antispam1: "BWH Hotels verlangen niemals persönliche Daten oder Zahlungen über WhatsApp- oder SMS-Nachrichten.",
                antispam2: "Im Zweifelsfall empfehlen wir Ihnen, sich direkt an die gebuchte Unterkunft zu wenden oder die Buchungswebsite zu nutzen.",
                mail_unsubscribe: " ",
                mail_unsubscribe_link: "Verwaltung der Benachrichtigungen für diese Buchung"
            }
        }
    },
    es: {
        shared: {
            footer: {
                hotel_text_communications: "Para cualquier solicitud relacionada con su estadía, puede escribir a ${hotel_email}",
                privacy_text_communications: "En cambio, exclusivamente para comunicaciones relacionadas con la privacidad o GDPR, puede contactarnos en ${privacy_email}",
                accessibility_text: "Declaración de accesibilidad",
                accessibility_link: "https://www-bestwestern-it.translate.goog/accessibility_bestfriend/?_x_tr_sl=it&_x_tr_tl=es&_x_tr_hl=es&_x_tr_pto=wapp",
                ownership: 'Each BWH® Hotels property is independently owned and operated.',
                antispam1: "BWH Hotels nunca solicitan datos personales ni el pago a través de mensajes de WhatsApp o SMS.",
                antispam2: "En caso de dudas, te recomendamos que contactes directamente con el establecimiento reservado o que accedas al sitio de reservas.",
                mail_unsubscribe: " ",
                mail_unsubscribe_link: "Gestión de las notificaciones de esta reserva"
            }
        }
    },
    fr: {
        shared: {
            footer: {
                hotel_text_communications: "Pour toute demande relative à votre séjour vous pouvez écrire à ${hotel_email}",
                privacy_text_communications: "Au lieu de cela, exclusivement pour les communications relatives à la confidentialité ou au RGPD, vous pouvez nous contacter à ${privacy_email}",
                accessibility_text: "Déclaration d'accessibilité",
                accessibility_link: "https://www-bestwestern-it.translate.goog/accessibility_bestfriend/?_x_tr_sl=it&_x_tr_tl=fr&_x_tr_hl=fr&_x_tr_pto=wapp",
                ownership: 'Each BWH® Hotels property is independently owned and operated.',
                antispam1: "BWH Hotels ne demandent jamais de données personnelles ni de paiement par messages WhatsApp ou SMS.",
                antispam2: "En cas de doute, nous vous conseillons de contacter directement l’établissement réservé ou d’accéder au site de réservation.",
                mail_unsubscribe: " ",
                mail_unsubscribe_link: "Gestion des notifications de cette réservation"
            }
        }
    },
    it: {
        shared: {
            footer: {
                hotel_text_communications: "Per qualsiasi richiesta relativa al tuo soggiorno puoi scriverci a ${hotel_email}",
                privacy_text_communications: "Esclusivamente per comunicazioni inerenti privacy o GDPR, puoi contattarci a ${privacy_email}",
                accessibility_text: "Dichiarazione di Accessibilità",
                accessibility_link: "https://www.bestwestern.it/accessibility_bestfriend/",
                ownership: 'Each BWH® Hotels property is independently owned and operated.',
                antispam1: "Gli alberghi BWH Hotels non chiedono mai dati personali e il pagamento tramite messaggi WhatsApp o SMS.",
                antispam2: "In caso di dubbi, ti consigliamo di contattare direttamente la struttura prenotata o di accedere al sito di prenotazione.",
                mail_unsubscribe: " ",
                mail_unsubscribe_link: "Gestione delle notifiche di questa prenotazione"
            }
        }
    }
};

export default translations;



// WEBPACK FOOTER //
// ./translations/shared/Footer.js